import React from 'react';
import PropTypes from 'prop-types';
import Map from '../google-map';
import StationMapInfoBox from './station-map-info-box';
import StationPropType from '../../../utils/prop-types/station';
import styles from './styles.css';

const StationProfileMap = ({ station, editMode, onMapInfoBoxPositionChange }) => {
  const center = {
    lat: station.latitude,
    lng: station.longitude,
  };

  return (
    <div style={{ height: '100%', minHeight: '200px' }} className={styles.mapContainer}>
      <Map
        editMode={editMode}
        center={center}
        onMapInfoBoxPositionChange={onMapInfoBoxPositionChange}
      >
        <StationMapInfoBox
          position={center}
          station={station}
          title={`#${station.retailer_reference}`}
        />
      </Map>
    </div>
  );
};

StationProfileMap.propTypes = {
  station: StationPropType.isRequired,
  editMode: PropTypes.bool,
  onMapInfoBoxPositionChange: PropTypes.func,
};

StationProfileMap.defaultProps = {
  onMapInfoBoxPositionChange: null,
  editMode: false,
};

export default StationProfileMap;
